// Chấm sao / nhận xét cho câu trả lời AI trong một phiên chat. Dùng chung cho
// ChatPanel và phần luận giải đầu tiên của Bói Đê (vốn nằm ngoài khung chat).
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { useBoideUser } from "@/hooks/use-boide-user";
import { rateChatMessage, type ChatMessage } from "@/lib/boide-api";

type ChatHistoryCache = { session_id: string; messages: ChatMessage[]; total: number };

type RateInput = {
  messageId: string;
  value: number | null;
  comment?: string | null;
};

export function chatHistoryKey(sessionId: string) {
  return ["chat-history", sessionId] as const;
}

export function useChatRating(sessionId: string) {
  const qc = useQueryClient();
  const { refresh: refreshUser } = useBoideUser();

  return useMutation({
    mutationFn: ({ messageId, value, comment }: RateInput) =>
      rateChatMessage(sessionId, messageId, value, comment),
    onMutate: ({ messageId, value, comment }) => {
      qc.setQueryData<ChatHistoryCache>(chatHistoryKey(sessionId), (old) =>
        old
          ? {
              ...old,
              messages: old.messages.map((m) =>
                m.id === messageId
                  ? {
                      ...m,
                      rating: value,
                      rating_comment: comment === undefined ? m.rating_comment : comment,
                    }
                  : m,
              ),
            }
          : old,
      );
    },
    onSuccess: (result, { messageId }) => {
      if (result.rating_comment_rewarded_at) {
        qc.setQueryData<ChatHistoryCache>(chatHistoryKey(sessionId), (old) =>
          old
            ? {
                ...old,
                messages: old.messages.map((m) =>
                  m.id === messageId
                    ? { ...m, rating_comment_rewarded_at: result.rating_comment_rewarded_at }
                    : m,
                ),
              }
            : old,
        );
      }
      if (result.rewarded) {
        toast.success("Đã hoàn 1.000đ vào ví cho nhận xét của bạn");
        refreshUser();
      }
    },
    onError: (e) => {
      qc.invalidateQueries({ queryKey: chatHistoryKey(sessionId) });
      toast.error(e instanceof Error ? e.message : "Không lưu được đánh giá");
    },
  });
}
